import { useSyncExternalStore } from 'react'

const subscribe = (callback: () => void) => {
  const controller = new AbortController()
  window.addEventListener('offline', callback, { signal: controller.signal })
  window.addEventListener('online', callback, { signal: controller.signal })

  return () => controller.abort()
}

const getIsOnline = () => navigator.onLine

export const useIsOnline = () => useSyncExternalStore(subscribe, getIsOnline)
